import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { LinkData, TemplateLinkComponent } from "../../templates/template-link/template-link.component";

@Component({
  selector: "app-prefix-lnk",
  imports: [TemplateLinkComponent],
  templateUrl: "./prefix-lnk.component.html",
  styleUrl: "./prefix-lnk.component.less",
})
export class PrefixLnkComponent extends PrefixComponent<LinkData[]> {
  @Input()
  public href: LinkData[];
  @Input()
  public routes: LinkData[];

  public constructor() {
    super();
    this.href = [];
    this.routes = [];
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["lnk"];
  }
}
